export const KeyLocalStore = {
  userSession: "userSession".trim(),
  accessToken: "accessToken".trim(),
  refreshToken: "refreshToken".trim(),
};
